import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from 'src/app/services/loader.service';

interface AcmAdminError extends Error {
  errorCode: string;
  errorSummary?: string;
  title?: string;
}

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.sass']
})
export class ErrorComponent implements OnInit {
  public error: AcmAdminError = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService
  ) {
  }

  ngOnInit(): void {
    this.loaderService.toggleLoader(false);
    const routerExtras = this.router.getCurrentNavigation();
    this.error = this.route.snapshot.data as AcmAdminError;
    if (routerExtras) {
      this.error = routerExtras.extras.state as AcmAdminError;
    }
  }

}
